module.exports = __webpack_public_path__ + "static/media/selenium.e3a8cc80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/selenium.png
// module id = 187
// module chunks = 0